/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Push_OffInputs */

const en_settings_push_off = /** @type {(inputs: Settings_Push_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get a push when a lesson is captured or needs confirming.`)
};

const he_settings_push_off = /** @type {(inputs: Settings_Push_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קבל התראה כשנקלט שיעור או כשנדרש אישור.`)
};

/**
* | output |
* | --- |
* | "Get a push when a lesson is captured or needs confirming." |
*
* @param {Settings_Push_OffInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_push_off = /** @type {((inputs?: Settings_Push_OffInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Push_OffInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_push_off(inputs)
	return he_settings_push_off(inputs)
});